<template>
<div>
  <heading>Hired Referrals</heading>
  <div v-if="hired && hired.length > 0 ">
    <!-- <row-card class="referrer-card"
      v-for="(referrer) in referrers" :key="referrer.id"
      :imageUrl="imageUrl(referrer)" :leftTitle="name(referrer)"
      :leftSubtitle="locations(referrer)"
      :rightTitle="role(referrer)"
      :rightSubtitle="company(referrer)"
      @click="onCardClicked(referrer)">
    </row-card> -->
    <user-ref-row-card
      v-for="(referrer) in hired" :key="referrer.id"
      :user="referrer" :referrer="referrer" class="referrer-card" @click="onCardClicked(referrer)" />
  </div>
  <empty-state v-else title="No Hired Referrals" icon="empty-state-eyes" >
    <template slot="content">
      <p class="text">Earn a percentage of a jobs pay, as a reward in HVT, if your referral for a job is hired.</p>
    </template>
  </empty-state>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Heading from '@/components/general/heading'
import EmptyState from '@/components/general/empty-state'
import UserRefRowCard from '@/components/applications/user-ref-row-card'

export default {
  components: { Heading, EmptyState, UserRefRowCard },
  computed: {
    ...mapState('hiredReferrals', [
      'referrers'
    ]),
    ...mapState('referrals', [
      'hired'
    ])
  },
  methods: {
    ...mapActions('referrals', [
      'getHired'
    ]),
    name (user) {
      return `${user.firstName} ${user.lastName}`
    },
    imageUrl (user) {
      return user.profilePictureUrl || `/api/identicons/${user.id}`
    },
    locations (user) {
      return user.location
    },
    role (user) {
      return user.role
    },
    company (user) {
      return user.companyName
    },
    onCardClicked (user) {
      // this.$router.push({path: `/jobseekers/${user.id}`})
    }
  },
  async mounted () {
    await this.getHired()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.card.referrer-card {
  cursor: pointer;
}

.card.referrer-card:hover {
  background-color: $hover-background;
}

.card.referrer-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.referrer-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/referrer/hired-referrals-section.vue